const MaxDimension=2048

// TODO: Currently this is a forced normalization. So even smaller images will get scaled up to the max dimension.
//  It's beneficial since the orientation info is not lost then due to the canvas and re-export.
export const normalizeImageFile = async (f: File) : Promise<Blob> => {
    return new Promise<Blob>(resolve => {
        const img = new Image()
        img.src = URL.createObjectURL(f)
        img.onload = (e: Event) => {
            URL.revokeObjectURL(img.src)
            const canvas = document.createElement('canvas')

            const imgWidth = (e.target! as HTMLImageElement).width
            const imgHeight = (e.target! as HTMLImageElement).height

            if (imgWidth > imgHeight) {
                canvas.width = MaxDimension
                canvas.height = MaxDimension/imgWidth*imgHeight
            } else {
                canvas.height = MaxDimension
                canvas.width = MaxDimension/imgHeight*imgWidth
            }
            const ctx = canvas.getContext('2d')
            ctx!.drawImage(e.target as HTMLImageElement, 0,0, canvas.width, canvas.height)
            ctx!.canvas.toBlob((blob) => {
                if (blob != null) {
                    resolve(blob)
                }
            }, "image/jpeg", 0.7)
        }})
}
